import { render } from "./MigracionActivosExternosProcesos.vue?vue&type=template&id=a4881694"
import script from "./MigracionActivosExternosProcesos.vue?vue&type=script&lang=js"
export * from "./MigracionActivosExternosProcesos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__